import React, {FC, memo} from 'react';
import {paypalBtnIcon} from '../../../images/svgIcons';

const PaymentFooter: FC<{confirm: () => void; paypal: boolean; loading: boolean}> = ({confirm, paypal, loading}) => (
  <>
    <div className="row">
      <div className="col-12 text-center">
        <button className={`btn confirm-and-pay  ${paypal ? 'paypal' : ''}`} onClick={confirm} disabled={loading}>
          {paypal ? (
            <>
              <span className="text">Pay with</span> <span className="icon">{paypalBtnIcon}</span>
            </>
          ) : (
            'Confirm and Pay'
          )}
        </button>
      </div>
    </div>
    {/* <div className="payment-text">
      {!paypal && 'We do not store your credit card information in our system at any point in time.'} Your payment
      information is securely transmitted to {paypal ? 'Paypal' : 'Stripe'}. If you have any questions, please don't
      hesitate to contact us at billing@hexact.io
    </div> */}
  </>
);

export default memo(PaymentFooter);
